export default __webpack_public_path__ + "static/media/csv.3c52b518.svg";